import {LegalAgreementLanguage, LegalAgreementVariable} from '@api';

const VARIABLE_TAG = /<span[^>]*data-legal-agreement-variable="([^"]*)"[^>]*>.*?<\/span>/g;

const SAMPLE_LOCALES: Record<LegalAgreementLanguage, string> = {
    [LegalAgreementLanguage.En]: 'en-GB',
    [LegalAgreementLanguage.Fr]: 'fr-FR',
    [LegalAgreementLanguage.Nl]: 'nl-NL',
    [LegalAgreementLanguage.De]: 'de-DE',
    [LegalAgreementLanguage.Es]: 'es-ES',
};

function escapeHtml(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function formatSignatureDate(date: Date, language: LegalAgreementLanguage): string {
    return new Intl.DateTimeFormat(SAMPLE_LOCALES[language], {day: 'numeric', month: 'long', year: 'numeric'}).format(date);
}

export function sampleVariableValues(
    language: LegalAgreementLanguage,
    signatureMention: (signatureDate: string) => string,
    today = new Date(),
): Record<string, string> {
    return {
        [LegalAgreementVariable.UmbrellaLegalName]: 'ACME Consulting',
        [LegalAgreementVariable.UmbrellaRegistrationNumber]: '123 456 789 00012',
        [LegalAgreementVariable.SignatureDate]: signatureMention(formatSignatureDate(today, language)),
    };
}

export function resolveLegalAgreementVariables(content: string, values: Record<string, string>): string {
    return content.replace(VARIABLE_TAG, (tag, variable: string) => (variable in values ? escapeHtml(values[variable]!) : tag));
}
